<div class="bg-[#F1F2F2]">
  <main class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="flex items-baseline justify-between pb-6 pt-3">
      <h1 class="text-3xl font-bold tracking-tight text-gray-700">My Dashboard</h1>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      <div class="relative inline-block bg-white p-3 rounded-xl shadow" *ngFor="let item of data">
        <div class="flex w-full">
          <input class="title" *ngIf="item.edit" [(ngModel)]="item.title">
          <h3 class="flex-auto tracking-wider font-semibold text-gray-600">{{item.title}}</h3>
          <div class="flex-none">
            <i class="fa-solid fa-pen-to-square px-2 cursor-pointer" (click)="rename(item)"></i>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 flex flex-col">
            <p class="text-sm text-amber-500">{{item.serviceRequests.length}} Services</p>
            <p class="text-sm text-blue-400">{{(item.fsis.length + item.sidemargins.length)}} Calculations</p>
          </div>
          <!-- <div class=" flex flex-col justify-center justify-items-center">
            <p
              class="inline-flex text-center items-end rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
              0 Updates</p>
          </div> -->

        </div>


        <div class="mt-5">
          <button class="w-full border border-blue-400 text-blue-400 p-1 rounded"
            [routerLink]="['/project',item._id]">Open</button>
        </div>

      </div>

      <div class="relative inline-block border border-slate-800 border-dashed p-3 rounded-xl cursor-pointer h-[142px]">
        <div class="grid items-center justify-items-center justify-center p-[25px]"
          (click)="openaddprojectModal()">
          <img src="assets/icons/add-folder.png" class="w-10">
          <h3 class="font-mono">Create New Project</h3>

        </div>

      </div>
    </div>
  </main>
</div>

<!-- Add Project Modal -->
<div id="addprojectModal" tabindex="-1" aria-hidden="true"
  class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative p-4 w-full max-w-md max-h-full">
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-2 md:p-3 border-b rounded-t dark:border-gray-600">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          Create New Project
        </h3>
        <button type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
         (click)="closeaddprojectModal()">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <form class="p-2 md:p-3">
        <div class="grid gap-4 mb-4 grid-cols-2">
          <div class="col-span-2">
            <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
            <input type="text" name="name" id="name" [(ngModel)]="title"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              placeholder="Enter project name" required="">
          </div>
        </div>
        <div class="sm:flex sm:flex-row-reverse">
          <button type="button"
            class="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
            (click)="create();closeaddprojectModal()"  >Submit</button>
          <button type="button"
            class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            (click)="closeaddprojectModal()">Cancel</button>
        </div>

      </form>
    </div>
  </div>
</div>

<app-fab-button></app-fab-button>